import React from "react"

const SearchIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1_23500)">
                <path d="M14.5835 14.5834L18.3335 18.3334" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M16.667 9.16669C16.667 5.02455 13.3091 1.66669 9.16699 1.66669C5.02486 1.66669 1.66699 5.02455 1.66699 9.16669C1.66699 13.3088 5.02486 16.6667 9.16699 16.6667C13.3091 16.6667 16.667 13.3088 16.667 9.16669Z" stroke="#2D2D2D" stroke-width="1.5" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1_23500">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}
export default SearchIcon